import { bootstrapApplication } from '@angular/platform-browser';
import 'chart.js/auto';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { relayMsalIframeResponse } from './core/auth/msal-redirect-bridge';
import { configureCharts, localeIdFor } from '#core';
import { readCachedLanguage } from '#services';

// A second app booted inside MSAL's renewal iframe never answers it and shares this tab's sign-in state.
if (!relayMsalIframeResponse()) {
  configureCharts(localeIdFor(readCachedLanguage()));
  bootstrapApplication(App, appConfig)
    .catch((err) => console.error(err));
}
